module.exports = __webpack_public_path__ + "media/images/lb/781-e7826b4d63c55eea8786dda6ed9074e7.svg";